<template>
    <Teleport to="body">
        <CreateRedemption v-if="showRedemptionCreateModal" />
        <EditRedemption v-if="showRedemptionEditModal" />

        <ShareTripModal
            :show="showShareModal"
            :trip="trip"
            :shareToken="shareToken"
            :loading="loading"
            @close="$emit('close-share')"
        />

        <ConfirmDialag
            :show="showDeleteRedemptionConfirm"
            title="Delete redemption"
            :subtitle="deleteRedemptionSubtitle"
            :dialog="deleteRedemptionDialogText"
            icon="trash"
            iconColor="red"
            @cancel="tripsStore.setShowDeleteRedemptionConfirm(false)"
            @confirm="tripsStore.deleteRedemption(activeRedemption?.uuid)"
            :buttons="[
                { type: 'cancel', text: 'Cancel' },
                {
                    type: 'confirm',
                    text: 'Delete redemption',
                    value: true,
                    classes: '!bg-red-500 !text-white hover:!bg-red-600',
                },
            ]"
        />

        <ConfirmDialag
            :show="showDeleteTripConfirm"
            title="Delete trip"
            dialog="You are about to delete the trip. This action cannot be undone."
            icon="trash"
            iconColor="red"
            :buttons="[
                { type: 'cancel', text: 'Cancel' },
                {
                    type: 'confirm',
                    text: 'Delete trip',
                    value: true,
                    classes: '!bg-red-500 !text-white',
                },
            ]"
        />

        <ConfirmDialag
            :show="showDeleteTripCoverConfirm"
            title="Delete trip cover image"
            dialog="You are about to delete the trip cover image. This action cannot be undone."
            icon="trash"
            iconColor="red"
            :buttons="[
                { type: 'cancel', text: 'Cancel' },
                {
                    type: 'confirm',
                    text: 'Delete Image',
                    value: true,
                    classes: '!bg-red-500 !text-white',
                },
            ]"
            @cancel="$emit('cancel-delete-trip-cover')"
            @confirm="$emit('confirm-clear-image')"
        />

        <ManageTrip />
        <RedemptionPanel v-if="showRedemptionPanel" />

        <EmailImportModal
            :show="showLearnMoreModal"
            :isSubscribed="isSubscribed"
            :userEmail="userEmail"
            @close="$emit('close-learn-more')"
        />
        <UpgradeModal
            :show="showUpgradeModal"
            description="This feature is part of the 10xTravel+ plan. Upgrade to unlock email import and other premium features."
            @close="$emit('close-upgrade')"
        />
    </Teleport>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useTripsStore } from '@/store/trips';
import CreateRedemption from '@/components/trips/modals/create-redemption.vue';
import EditRedemption from '@/components/trips/modals/edit-redemption.vue';
import ShareTripModal from '@/components/trips/modals/share-trip-modal.vue';
import ConfirmDialag from '@/components/ui/confirmation-dialog/confirmation-dialog.vue';
import ManageTrip from '@/components/trips/modals/manage-trip.vue';
import RedemptionPanel from '@/components/trips/redemptions/redemption-panel.vue';
import EmailImportModal from '@/components/trips/modals/email-import-modal.vue';
import UpgradeModal from '@/modals/upgrade-modal.vue';

const tripsStore = useTripsStore();
const {
    showRedemptionCreateModal,
    showRedemptionEditModal,
    showRedemptionPanel,
    activeRedemption,
    showDeleteRedemptionConfirm,
} = storeToRefs(tripsStore);

defineProps({
    trip: { type: Object, required: true },
    showShareModal: { type: Boolean, default: false },
    shareToken: { type: String, default: null },
    loading: { type: Boolean, default: false },
    showDeleteTripConfirm: { type: Boolean, default: false },
    showDeleteTripCoverConfirm: { type: Boolean, default: false },
    deleteRedemptionSubtitle: { type: String, default: '' },
    deleteRedemptionDialogText: { type: String, default: '' },
    showLearnMoreModal: { type: Boolean, default: false },
    showUpgradeModal: { type: Boolean, default: false },
    isSubscribed: { type: Boolean, default: false },
    userEmail: { type: String, default: '' },
});

defineEmits([
    'close-share',
    'cancel-delete-trip-cover',
    'confirm-clear-image',
    'close-learn-more',
    'close-upgrade',
]);
</script>
